import { KEY_REDUCER_SW } from "@/shared/store/sw/constants";

export const selectorNamedCacheKeysAvailable = (state) => {
  return state[KEY_REDUCER_SW].namedCacheKeysAvailable;
};